module.exports = __webpack_public_path__ + "static/media/game-active.22cbb7cf.svg";